import { useEffect, useRef } from "react";
import { registerTour, unregisterTour } from "../tourRegistry";

/**
 * Announce to the header's help menu that this tour can be started right now.
 *
 * `start` goes through a ref because every tour hook in the app re-creates its
 * handleStartTutorial on each render (they are plain arrows, not useCallback);
 * depending on it directly would re-register on every render. Only `id` and
 * `enabled` actually change registration.
 *
 * `enabled` is for owners that outlive the screen they narrate — SubNav is
 * mounted for every tab, so its three tours gate on the active one. Owners that
 * only mount when their modal is open need no gate.
 */
export default function useTourRegistration(id, start, enabled = true) {
    const startRef = useRef(start);
    startRef.current = start;

    useEffect(() => {
        if (!id || !enabled) return;
        const invoke = () => startRef.current?.();
        registerTour(id, invoke);
        return () => unregisterTour(id, invoke);
    }, [id, enabled]);
}
